module.exports = __webpack_public_path__ + "a68140c24444bc82b3117db23f85339c.svg";